import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=0b346d68&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
import style0 from "../assets/styles-new/footer.sass?vue&type=style&index=0&id=0b346d68&prod&lang=sass&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b346d68",
  null
  
)

export default component.exports